import {
  APP_ROUTES,
  APP_CHAT_ROUTES as CHAT,
  APP_SETTINGS_ROUTES as SETTINGS,
} from "@/Generated/Routes/paths";

export const isSettingsCustomerRootPage = (name: unknown) => CHAT.customer.root.name === name;

export const isSettingsCustomerQuestionnairesForPage = (name: unknown) =>
  CHAT.customer.questionnaires.root.name === name;

export const isSettingsCustomerQuestionnairesAnswersPage = (name: unknown) =>
  CHAT.customer.questionnaires.answers.root.name === name;

export const isSettingsCustomerSchedulePage = (name: unknown) => CHAT.customer.schedule.root.name === name;

export const isSettingsHelpPage = (name: unknown) => SETTINGS.help.view.root.name === name;

export const isActivityCenterPage = (name: unknown) => APP_ROUTES.activity.root.name === name;

export const isSettingsInvoicesPage = (name: unknown) => SETTINGS.invoices.root.name === name;

export const cleanCanonical = (path: string) => {
  return path.substring(1);
};
